module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_06.750693e6.jpg";